export const INITIAL_STRIPE_CONTEXT = {
    setStripeAmount: null
};
